// extracted by mini-css-extract-plugin
export default {"wrapper":"EmptyStatePlaceholder_wrapper__vef-9","message":"EmptyStatePlaceholder_message__7C13i"};